var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"sv-app",attrs:{"id":"aunfcms-app"}},[_c('sidebar',{ref:"refsidebar",attrs:{"title":_vm.siteName}}),_vm._v(" "),_c('toolbar',{on:{"showSidebar":_vm.onShowSidebarRequest}}),_vm._v(" "),_c('v-main',{staticClass:"mx-3"},[_c('router-view',{key:_vm.$route.path})],1),_vm._v(" "),_c('confirm-dialog',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }